/* eslint max-len: ["error", 1000] */
import React from 'react';

const ForecastRainThunder = (): React.ReactElement => (
    <svg
        version="1.1"
        className="weather-icon"
        width="30px"
        height="30px"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 30 30"
    >
        <path d="M7.4,22.2c0.3-0.6,0.1-1.3-0.5-1.6c-0.6-0.3-1.3-0.1-1.6,0.5L4,23.4C3.6,24,3.8,24.7,4.4,25 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6L7.4,22.2z" />
        <path d="M24.3,20.5c-0.6-0.3-1.3-0.1-1.6,0.5l-1.3,2.4c-0.3,0.6-0.1,1.3,0.5,1.6c0.2,0.1,0.4,0.2,0.6,0.2 c0.4,0,0.8-0.2,1-0.6l1.3-2.4C25.1,21.6,24.9,20.9,24.3,20.5z" />
        <path d="M9.1,24.6c-0.6-0.3-1.3-0.1-1.6,0.5l-1.3,2.4c-0.3,0.6-0.1,1.3,0.5,1.6c0.2,0.1,0.4,0.2,0.6,0.2 c0.4,0,0.8-0.2,1-0.6l1.3-2.4C9.9,25.7,9.7,25,9.1,24.6z" />
        <path d="M19.1,24.6c-0.6-0.3-1.3-0.1-1.6,0.5l-1.4,2.4c-0.3,0.6-0.1,1.3,0.5,1.6c0.2,0.1,0.4,0.2,0.6,0.2 c0.4,0,0.8-0.2,1-0.6l1.3-2.4C19.9,25.7,19.7,25,19.1,24.6z" />
        <path
            d="M22.5,6.3h-0.8c-0.5-1.6-1.4-3.1-2.7-4.2C17.4,0.8,15.4,0,13.3,0C9.1,0,5.5,3,4.7,7C2.5,8.1,1,10.3,1,12.9 c0,3.6,2.9,6.5,6.5,6.5h1.8c0.7,0,1.2-0.5,1.2-1.2S10,17,9.3,17H7.5c-2.3,0-4.1-1.8-4.1-4.1c0-1.8,1.1-3.3,2.8-3.9l0.7-0.3L7,8
            c0.4-3.2,3.1-5.6,6.3-5.6c3.1,0,5.8,2.3,6.3,5.4l0.2,1h2.7c2.3,0,4.1,1.8,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1h-0.7 c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2h0.7c3.6,0,6.5-3,6.5-6.6C29,9.2,26.1,6.3,22.5,6.3z"
        />
        <path
            d="M18.9,17.9c-0.1-0.2-0.3-0.3-0.5-0.3h-2.3l2.5-4.3c0.1-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.3-0.2-0.4-0.2h-2.9 c-0.2,0-0.5,0.2-0.5,0.4l-3,7.2c-0.1,0.2,0,0.4,0.1,0.5c0.1,0.1,0.3,0.2,0.4,0.2h2l-2.4,4.5c-0.4,0.6-0.2,1.3,0.4,1.7
            c0.6,0.3,1.3,0.1,1.6-0.5l5.1-8.2C19,18.3,19,18.1,18.9,17.9z"
        />
    </svg>
);
export default ForecastRainThunder;
